import React, { useEffect, useState } from "react";
import ContactsInformation from "./ContactsInfomation";
import { Accordion, AccordionSummary, AccordionDetails, Typography, Tooltip } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "./CompanyContactsPage.css";
import { PageLoader } from "../../component/loader/PLoader";
import { getCompanyDetails } from "../../service/adminService";
import { useQuery } from "@tanstack/react-query";
import useUser from "../../hooks/useUser";
import ErrorHandler from "../../component/errors/ErrorHandler";
import { useTranslation } from "react-i18next";
import RoleDescriptionMatrix from "../../component/tables/RoleDescriptionMatrix";
import { InfoOutlined } from "@mui/icons-material";

const CompanyContactsPage = () => {
	const { t } = useTranslation();
	const { activeUserEmail } = useUser();
	const [permissions, setPermissions] = useState(null);
	const [companyInfo, setCompanyInfo] = useState(null);
	const [contacts, setContacts] = useState([]);
	const [expandedSections, setExpandedSections] = useState({
		roleDescription: true,
	});
	const toggleSection = (sectionName) => {
		setExpandedSections((prev) => ({
			...prev,
			[sectionName]: !prev[sectionName],
		}));
	};
	const { isFetching, data, error } = useQuery({
		queryKey: ["companyDetails", activeUserEmail],
		queryFn: getCompanyDetails,
	});

	useEffect(() => {
		if (data) {
			setCompanyInfo(data?.companyInfo);
			setContacts(data?.usersList);
			setPermissions(data?.permissions);
		}
	}, [data]);

	if (isFetching) return <PageLoader show/>;
	if(error){
		return <ErrorHandler title={"Something went wrong"} desc={"Please try again later."}/>
	}

	return (
		<div className='container'>
			<div className='accordion-container'>
				{companyInfo && (
					<div className='companyInfo'>
						<div>
							<h1 className='companyInfo--title' title={t("Company Name")}>
								{companyInfo?.soldto_name}
							</h1>
							<div className='companyInfo--soldTo'>
								<h2>{companyInfo?.soldto_number} </h2>
								<Tooltip title={t("Account Number")} style={{marginTop:"2px"}}>
									<InfoOutlined className='mui-icon' fontSize='6px' />
								</Tooltip>
							</div>
						</div>
						<hr></hr>
						<div>
							<p title={t("Street")}>{companyInfo?.shipto_street_line1}</p>
							<p>
								<span title={t("City")}>{companyInfo?.shipto_city}</span>
								<span>, </span>
								<span title={t("State")}>{companyInfo?.shipto_region}</span>
								<span title={t("Zip")}>{companyInfo?.shipto_postal_code}</span>
							</p>
							<p title={t("Country")}>{companyInfo?.country}</p>
						</div>
					</div>
				)}
				<br></br>
				{contacts && (
					<ContactsInformation
						contacts={contacts}
						permissions={permissions}
					/>
				)}
				<Accordion expanded={expandedSections.roleDescription} onChange={() => toggleSection("roleDescription")}>
					<AccordionSummary expandIcon={<ExpandMoreIcon />}>
						<Typography sx={{ fontWeight: "550" }}>{t("Role Description")}</Typography>
					</AccordionSummary>
					<AccordionDetails>
						<RoleDescriptionMatrix />
					</AccordionDetails>
				</Accordion>
			</div>
		</div>
	);
};

export default CompanyContactsPage;
